import { createAction } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

import type { BlotterOrderEntry } from '@/store/blotter/types/BlotterOrderEntry.ts';
import type { OrderMode } from '@/store/types.ts';

/**
 * The summonOrder action creates a new tile to represent an existing order and allow alter to view/edit it
 * It is handled by multiple slices for state modification and effects
 */
export const summonOrder = createAction(
  'blotter/summonOrder',
  (entry: BlotterOrderEntry, mode: OrderMode, activeTabId: string) => ({
    payload: {
      tileId: uuidv4(),
      tabId: activeTabId,
      entry,
      mode,
    },
  }),
);
